import React, { useState } from 'react';
import { Head } from 'vite-react-ssg';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CustomCursor from '@/components/CustomCursor';

// ── Data ──────────────────────────────────────────────────────────────────────

const ladyVAC = {
  name: 'Archana Namireddy',
  image: '/assets/team/Archana.jpg',
  title: 'Black Diamond Ambassador',
  location: 'Hyderabad, Telangana',
  since: 'A Vivaite since 2016',
  description: 'A strategist with a heart for team growth and success.',
  facebook: 'https://www.facebook.com/archana.namireddy',
  instagram: 'https://www.instagram.com/archananamireddy/',
};

const leadership = [
  { name: 'Prem Kumar', image: '/assets/team/Prem Kumar.jpg', title: 'Royal Black Diamond Ambassador', location: 'Bangalore, Karnataka', since: 'A Vivaite since 2014', description: 'A leader driven by integrity, vision, and commitment to people.', facebook: 'https://www.facebook.com/vivacrownprem', instagram: 'https://www.instagram.com/leadwithprem' },
  { name: 'Sujid Khan', image: '/assets/team/Sujid.jpg', title: 'Black Diamond Ambassador', location: 'Malappuram, Kerala', since: 'A Vivaite since 2014', description: 'A mentor who leads with empathy and inspires through action.', facebook: 'https://www.facebook.com/sujidkhan009', instagram: 'https://www.instagram.com/sujid_khan' },
  { name: 'Suraj Kant', image: '/assets/team/Suraj.jpg', title: 'Executive White Diamond', location: 'Pathankot, Punjab', since: 'A Vivaite since 2014', description: 'A strong decision-maker with a passion for excellence.', facebook: 'https://www.facebook.com/suraj.kant.908', instagram: 'https://www.instagram.com/surajkant555' },
  { name: 'Pramod Pruthi', image: '/assets/team/Pramod Pruthi.jpg', title: 'Black Diamond Ambassador', location: 'Ambala, Haryana', since: 'A Vivaite since 2014', description: 'A guide who believes in lifting others as they rise.', facebook: 'https://www.facebook.com/pramod.pruthi.3', instagram: 'https://www.instagram.com/pramodpruthi' },
  { name: 'Rajesh Kumar', image: '/assets/team/Rajesh Kumar.jpg', title: 'Black Diamond Ambassador', location: 'Kottayam, Kerala', since: 'A Vivaite since 2016', description: 'A focused achiever with an unwavering positive attitude.', facebook: 'https://www.facebook.com/rajeshkumar.k.9469', instagram: 'https://www.instagram.com/haiiamrk007' },
  { name: 'Anish Varghese', image: '/assets/team/Anish.jpg', title: 'Black Diamond Ambassador', location: 'Bangalore, Karnataka', since: 'A Vivaite since 2014', description: 'A people-centric leader creating opportunities for many.', facebook: 'https://www.facebook.com/anish.varghese.739', instagram: 'https://www.instagram.com/anishvarghese007' },
  { name: 'MuhammedAli', image: '/assets/team/Muhammedali .jpg', title: 'Executive White Diamond', location: 'Kozhikode, Kerala', since: 'A Vivaite since 2016', description: 'A visionary who turns possibilities into performance.', facebook: 'https://www.facebook.com/muhammedali.pothuvath', instagram: 'https://www.instagram.com/alibhai_viva' },
  { name: 'Jeevanand', image: '/assets/team/Jeevanand.jpg', title: 'Black Diamond Ambassador', location: 'Thrissur, Kerala', since: 'A Vivaite since 2014', description: 'A personality that blends humility with powerful leadership.', facebook: 'https://www.facebook.com/jeevanand.sreedharan', instagram: 'https://www.instagram.com/jeevan_and_yes' },
  { name: 'Syed Franchis Hussain', image: '/assets/team/Syed.jpg', title: 'Executive White Diamond', location: 'Guwahati, Assam', since: 'A Vivaite since 2016', description: 'A role model who leads by example every single day.', facebook: 'https://www.facebook.com/franchishussain', instagram: 'https://www.instagram.com/syedfranchishussainofficial' },
];

// ── Icons ─────────────────────────────────────────────────────────────────────

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.886v2.267h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

const LocationIcon = () => (
  <svg className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
  </svg>
);

const CalendarIcon = () => (
  <svg className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
  </svg>
);

// ── Social Media Links ────────────────────────────────────────────────────────

const SocialLinks = ({ member, small = false }) => (
  <div className="flex items-center gap-2" onClick={e => e.stopPropagation()}>
    {member.facebook && (
      <a
        href={member.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center justify-center rounded-full bg-white/10 hover:bg-[#1877F2] text-white/70 hover:text-white transition-all duration-300 ${small ? 'w-7 h-7' : 'w-8 h-8'}`}
        aria-label={`${member.name} Facebook`}
      >
        <FacebookIcon />
      </a>
    )}
    {member.instagram && (
      <a
        href={member.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center justify-center rounded-full bg-white/10 hover:bg-gradient-to-br hover:from-[#f09433] hover:via-[#e6683c] hover:via-[#dc2743] hover:via-[#cc2366] hover:to-[#bc1888] text-white/70 hover:text-white transition-all duration-300 ${small ? 'w-7 h-7' : 'w-8 h-8'}`}
        aria-label={`${member.name} Instagram`}
      >
        <InstagramIcon />
      </a>
    )}
  </div>
);

// ── Team Card ─────────────────────────────────────────────────────────────────

const TeamCard = ({ member, onPhotoClick }) => (
  <div
    className="group relative overflow-hidden rounded-2xl transition-all duration-500 hover:shadow-2xl hover:scale-[1.02] cursor-pointer"
    onClick={() => onPhotoClick(member)}
  >
    <div className="relative h-[400px] overflow-hidden bg-gradient-to-br from-[#1e3a5f] via-[#2a5298] to-[#1e3a5f]">
      <img
        src={member.image}
        alt={member.name}
        className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
        style={{ filter: 'brightness(1.15)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0f1f35]/95 via-[#0f1f35]/40 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-6">
        <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 'clamp(18px,2vw,24px)', color: 'white', marginBottom: '4px', letterSpacing: '-0.01em' }}>
          {member.name}
        </h3>
        <p style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400, fontSize: '12px', color: 'rgba(200,220,255,0.8)', marginBottom: '14px' }}>
          {member.title}
        </p>
        <SocialLinks member={member} small />
      </div>
    </div>
  </div>
);

// ── Modal ─────────────────────────────────────────────────────────────────────

const Modal = ({ member, onClose }) => {
  if (!member) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-end md:items-center justify-center bg-black/70 backdrop-blur-sm overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-t-2xl md:rounded-2xl shadow-2xl max-w-4xl w-full md:mx-4 md:my-8 max-h-[92vh] md:max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex flex-col md:flex-row">
          <div className="md:w-2/5 relative bg-gradient-to-br from-[#1e3a5f] via-[#2a5298] to-[#1e3a5f] p-8 flex items-center justify-center">
            {member.badge && (
              <div className="absolute top-4 left-4">
                <span style={{ fontFamily: "'Outfit', sans-serif" }} className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-blue-600/90 text-white text-xs font-500 tracking-widest uppercase">
                  <span className="w-1 h-1 rounded-full bg-white animate-pulse" />
                  {member.badge}
                </span>
              </div>
            )}
            <div className="relative w-full">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400/30 to-blue-600/30 rounded-lg blur-2xl" />
              <img src={member.image} alt={member.name} className="relative w-full h-auto rounded-lg object-cover shadow-2xl border-4 border-white/20" />
            </div>
          </div>

          <div className="md:w-3/5 p-8 md:p-12 relative">
            <button
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-red-500 hover:text-white text-gray-600 transition-all duration-300"
              onClick={onClose} aria-label="Close"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="mt-4">
              <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 'clamp(26px,3vw,36px)', color: '#111827', marginBottom: '8px' }}>
                {member.name}
              </h2>
              <h3 style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 500, fontSize: '15px', color: '#2563eb', marginBottom: '20px' }}>
                {member.title}
              </h3>
              <div className="w-16 h-1 bg-blue-600 mb-6 rounded-full" />

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <LocationIcon />
                  <p style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400, fontSize: '14px', color: '#374151', lineHeight: 1.7 }}>{member.location}</p>
                </div>
                <div className="flex items-start gap-3">
                  <CalendarIcon />
                  <p style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400, fontSize: '14px', color: '#374151', lineHeight: 1.7 }}>{member.since}</p>
                </div>
                <div className="flex items-start gap-3">
                  <svg className="w-4 h-4 text-blue-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                    <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                  </svg>
                  <p style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400, fontSize: '14px', color: '#374151', lineHeight: 1.7 }}>{member.description}</p>
                </div>
              </div>

              <div>
                <p style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 500, fontSize: '12px', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af', marginBottom: '12px' }}>
                  Connect
                </p>
                <div className="flex gap-3">
                  {member.facebook && (
                    <a href={member.facebook} target="_blank" rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#1877F2] text-white text-sm font-500 hover:opacity-90 transition-opacity"
                      style={{ fontFamily: "'Outfit', sans-serif" }}
                    >
                      <FacebookIcon /> Facebook
                    </a>
                  )}
                  {member.instagram && (
                    <a href={member.instagram} target="_blank" rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 rounded-full text-white text-sm font-500 hover:opacity-90 transition-opacity"
                      style={{ fontFamily: "'Outfit', sans-serif", background: 'linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)' }}
                    >
                      <InstagramIcon /> Instagram
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ── Page ──────────────────────────────────────────────────────────────────────

const Leadership = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.05 });

  const silk = [0.25, 0.46, 0.45, 0.94];
  const expo = [0.16, 1, 0.3, 1];

  const eyebrowV = { hidden: { opacity: 0, y: 14 }, visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: silk } } };
  const wordV = { hidden: { opacity: 0, y: 44, rotateX: 14 }, visible: { opacity: 1, y: 0, rotateX: 0, transition: { duration: 0.8, ease: expo } } };
  const italicV = { hidden: { opacity: 0, x: -36, skewX: -5 }, visible: { opacity: 1, x: 0, skewX: 0, transition: { duration: 0.7, ease: expo } } };
  const cardV = { hidden: { opacity: 0, y: 48, scale: 0.97 }, visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 1.2, ease: expo } } };

  const rows = [];
  for (let i = 0; i < leadership.length; i += 3) {
    rows.push(leadership.slice(i, i + 3));
  }

  return (
    <>

      <Head>
        {/* ── Basic Meta ── */}
        <title>VibrantViva Leadership | Visionary Leaders Driving Growth and Success</title>
        <meta
          name="description"
          content="Meet the VibrantViva leadership team of visionary leaders and business mentors driving entrepreneurship, leadership development, organizational growth, and long-term success."
        />
        <meta
          name="keywords"
          content="Business Leadership Team, Entrepreneurial Leadership, Visionary Leaders, Business Mentors, leadership development in business, visionary business leaders, leadership and business growth, inspiring leadership examples, successful business leadership team, Leadership and Organizational Growth, Leadership Development, Professional Growth, VibrantViva Leadership"
        />
        <meta name="author" content="VibrantViva" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vibrantviva.com/leadership" />

        {/* ── Open Graph ── */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://vibrantviva.com/leadership" />
        <meta
          property="og:title"
          content="VibrantViva Leadership | Visionary Leaders Driving Growth & Success"
        />
        <meta
          property="og:description"
          content="Meet the VibrantViva leadership team of visionary leaders and business mentors driving entrepreneurship, leadership development, organizational growth, and long-term success."
        />
        <meta property="og:image" content="https://vibrantviva.com/assets/logo.png" />
        <meta property="og:image:width" content="200" />
        <meta property="og:image:height" content="200" />
        <meta property="og:site_name" content="VibrantViva" />
        <meta property="og:locale" content="en_IN" />

        {/* ── JSON-LD Structured Data ── */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "CollectionPage",
              "url": "https://vibrantviva.com/leadership",
              "name": "VibrantViva Leadership",
              "description":
                "Meet the VibrantViva leadership team of visionary leaders and business mentors driving entrepreneurship, leadership development, organizational growth, and long-term success.",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "name": "VibrantViva",
                "url": "https://vibrantviva.com/"
              },
              "publisher": {
                "@type": "Organization",
                "name": "VibrantViva",
                "url": "https://vibrantviva.com/",
                "logo": "https://vibrantviva.com/assets/logo.png",
                "sameAs": [
                  "https://www.facebook.com/media/set/?vanity=officialVibrantViva&set=a.705168821617957",
                  "https://www.instagram.com/vibrantvivaofficial/",
                  "https://www.linkedin.com/company/indusviva-healthsciences-private-limited/posts/?feedView=all&viewAsMember=true",
                  "https://x.com/IndusvivaPvt?t=yf_P18W0HW6DR9ZbrhjRzg&s=09",
                  "https://www.youtube.com/@VibrantViva"
                ],
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+91-1800-103-4916",
                  "contactType": "Customer Support",
                  "hoursAvailable": [
                    {
                      "@type": "OpeningHoursSpecification",
                      "dayOfWeek": [
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday"
                      ],
                      "opens": "09:30",
                      "closes": "18:00"
                    },
                    {
                      "@type": "OpeningHoursSpecification",
                      "dayOfWeek": ["Saturday"],
                      "opens": "09:30",
                      "closes": "13:30"
                    }
                  ],
                  "availableLanguage": [
                    "English",
                    "Hindi",
                    "Kannada",
                    "Tamil",
                    "Telugu",
                    "Malayalam"
                  ],
                  "areaServed": "IN",
                  "contactOption": "TollFree"
                },
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress":
                    "No 92-1-36, Viva Tower, Nandi Durga Road, Jayamahal Extension",
                  "addressLocality": "Bangalore Urban",
                  "addressRegion": "Karnataka",
                  "postalCode": "560046",
                  "addressCountry": "IN"
                },
                "location": {
                  "@type": "Place",
                  "name": "Viva Tower",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress":
                      "No 92-1-36, Viva Tower, Nandi Durga Road, Jayamahal Extension",
                    "addressLocality": "Bangalore Urban",
                    "addressRegion": "Karnataka",
                    "postalCode": "560046",
                    "addressCountry": "IN"
                  }
                }
              },
              "mainEntity": {
                "@type": "ItemList",
                "name": "VibrantViva Leadership Team",
                "description":
                  "A team of visionary leaders, business mentors, and entrepreneurial professionals driving leadership development and organizational growth."
              }
            })
          }
          } />
      </Head>


      <style dangerouslySetInnerHTML={{
        __html: `
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Outfit:wght@300;400;500;600;700&display=swap');
        .leadership-root, .leadership-root *, .leadership-root *::before, .leadership-root *::after {
          font-family: 'Outfit', sans-serif;
        }
        .leadership-root h1, .leadership-root h2,
        .leadership-root h3, .leadership-root h4 {
          font-family: 'Cormorant Garamond', serif;
        }
      `}} />

      <div className="leadership-root">
        <Header />
        <CustomCursor />

        {/* ── Navy hero banner ── */}
        <div style={{ background: '#0f1e38', paddingBottom: '52px' }}>
          <div ref={ref} className="container mx-auto px-6 max-w-6xl pt-32">

            <motion.p
              style={{ fontFamily: "'Outfit', sans-serif", fontSize: '0.6rem', fontWeight: 500, letterSpacing: '0.3em', textTransform: 'uppercase', color: '#8fafd4', display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}
              variants={eyebrowV} initial="hidden" animate={inView ? 'visible' : 'hidden'}
            >
              <span style={{ display: 'inline-block', width: '32px', height: '1px', background: '#3b82f6' }} />
              People & Culture
            </motion.p>

            <div className="flex flex-col md:flex-row md:items-end gap-4 md:gap-7 mb-4">
              <motion.h1
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500, letterSpacing: '-0.02em', lineHeight: 1.1, color: '#ffffff', perspective: '700px' }}
                className="text-4xl md:text-5xl"
                variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.12, delayChildren: 0.18 } } }}
                initial="hidden" animate={inView ? 'visible' : 'hidden'}
              >
                <span style={{ display: 'flex', flexWrap: 'wrap', gap: '0 0.3em' }}>
                  {['Meet', 'Our'].map(w => (
                    <motion.span key={w} variants={wordV} style={{ display: 'inline-block' }}>{w}</motion.span>
                  ))}
                </span>
                <motion.span
                  style={{ fontStyle: 'italic', fontWeight: 400, color: '#3b82f6', display: 'block', marginTop: '4px' }}
                  variants={italicV}
                >
                  Leadership
                </motion.span>
              </motion.h1>

              {/* divider stays desktop-only — it's a vertical rule meant to sit between columns */}
              <motion.div
                style={{ width: 1, alignSelf: 'stretch', background: 'linear-gradient(to bottom, transparent, rgba(59,130,246,0.5), transparent)', marginBottom: 4 }}
                className="hidden md:block"
                initial={{ opacity: 0, scaleY: 0.5 }}
                animate={inView ? { opacity: 1, scaleY: 1 } : {}}
                transition={{ duration: 0.7, ease: expo }}
              />

              {/* paragraph now shows on all breakpoints */}
              <motion.p
                style={{ fontFamily: "'Outfit', sans-serif", fontSize: '0.82rem', color: 'rgba(200,220,255,0.7)', fontWeight: 300, lineHeight: 1.75, maxWidth: '380px', marginBottom: 4 }}
                variants={eyebrowV} initial="hidden" animate={inView ? 'visible' : 'hidden'}
              >
                Visionary leaders shaping the future of direct selling with integrity, passion, and purpose.
              </motion.p>
            </div>

            <motion.div
              style={{ height: '1px', background: 'linear-gradient(to right, rgba(59,130,246,0.5), transparent)', marginTop: '20px' }}
              initial={{ opacity: 0, scaleX: 0.5 }}
              animate={inView ? { opacity: 1, scaleX: 1 } : {}}
              transition={{ duration: 0.7, ease: expo }}
            />
          </div>
        </div>

        {/* ── Content ── */}
        <section className="py-32 px-8 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto">

            {/* ── Row 1: Lady VAC center-aligned ── */}
            <motion.div
              className="grid grid-cols-1 md:grid-cols-3 gap-x-14 gap-y-14 mb-14"
              variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.1 } } }}
              initial="hidden" animate={inView ? 'visible' : 'hidden'}
            >
              <div className="hidden md:block" />
              <motion.div variants={cardV} className="relative">
                <div className="absolute top-4 left-4 z-10">
                  {/* <span style={{ fontFamily:"'Outfit', sans-serif" }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-600/90 backdrop-blur-sm text-white text-xs font-500 tracking-widest uppercase shadow-lg">
                    <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
                    Lady VAC
                  </span> */}
                </div>
                <TeamCard member={ladyVAC} onPhotoClick={setSelectedMember} />
              </motion.div>
              <div className="hidden md:block" />
            </motion.div>

            {/* ── Divider ── */}
            <div className="flex items-center gap-4 mb-24">
              <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent" />
              <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent" />
            </div>

            {/* ── Remaining leaders — rows of 3 ── */}
            <div className="space-y-20">
              {rows.map((row, rowIdx) => (
                <motion.div
                  key={rowIdx}
                  className="grid grid-cols-1 md:grid-cols-3 gap-x-14 gap-y-14"
                  variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.1, delayChildren: rowIdx * 0.08 } } }}
                  initial="hidden"
                  animate={inView ? 'visible' : 'hidden'}
                >
                  {row.map((member, idx) => (
                    <motion.div key={idx} variants={cardV}>
                      <TeamCard member={member} onPhotoClick={setSelectedMember} />
                    </motion.div>
                  ))}
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Modal ── */}
        <Modal member={selectedMember} onClose={() => setSelectedMember(null)} />

        <Footer />
      </div>
    </>
  );
};

export default Leadership;